import { JSX } from "react";
import { useSearchParams } from "react-router-dom";

import SubscriptionCard from "@/components/cards/SubscriptionCard/SubscriptionCard.tsx";

import { useGetSubscriptions, useGetUser } from "@/hooks/api/user.hooks";
import { mergeSubscriptions } from "@/utils/subscription";

const SubscriptionsPage = (): JSX.Element => {
  const { data: subs } = useGetSubscriptions();
  const { data: user } = useGetUser();

  const [params] = useSearchParams();

  const userSubs = user.subscriptions;

  const allowed = params.get("allowed");

  const mergedSubs = mergeSubscriptions(subs, userSubs, allowed);

  return (
    <>
      <h1 className={"mt-10 text-center text-[2rem]/10 font-semibold max-lg:text-2xl"}>Выберите подходящую подписку</h1>
      <div className={"mt-12 flex flex-wrap justify-center gap-12 max-lg:gap-4"}>
        {mergedSubs.map((subscription) => (
          <SubscriptionCard key={subscription.id} {...subscription} />
        ))}
      </div>
    </>
  );
};

export default SubscriptionsPage;
